import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { IReqIdentifier } from '../../shared/interfaces/req-identifier';
import { ToggleHide, ToggleShow } from '../../shared/store/actions/loader.actions';
import { LoaderStatusEnum } from '../../shared/enums/loader-status.enum';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private requestsToSkip: IReqIdentifier[];

    constructor(private store: Store) {
        this.requestsToSkip = [];
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.get(LoaderStatusEnum.BYPASS_FULL_LOADER) === 'true') {
            const clonedReq: HttpRequest<any> = req.clone({
                headers: req.headers.delete(LoaderStatusEnum.BYPASS_FULL_LOADER),
            });

            const alreadyRegistered: boolean = this.requestsToSkip.some(
                (obj: IReqIdentifier) => obj.id === req.url && obj.method === req.method
            );

            if (!alreadyRegistered) {
                this.requestsToSkip.push({
                    id: req.url,
                    method: req.method,
                });
            }

            return next.handle(clonedReq);
        }
        this.store.dispatch(new ToggleShow());

        /*
            Finalize instead of tap + catcherror looks like it works, keeping
            code commented for now cause it might break (not checking if instance of httpResponse before hiding)
        */
        return next.handle(req).pipe(
            finalize(() => {
                const isReqToSkip: boolean = this.requestsToSkip.some(
                    (obj: IReqIdentifier) => obj.id === req.url && obj.method === req.method
                );

                if (!isReqToSkip) {
                    this.store.dispatch(new ToggleHide());
                }
            })
            // tap((res: HttpEvent<any>) => {
            //     if (res instanceof HttpResponse) {
            //         this.store.dispatch(new ToggleHide());
            //     }
            // }),
            // catchError((err: HttpEvent<any>) => {
            //     this.store.dispatch(new ToggleHide());
            //     return throwError(err);
            // })
        );
    }
}
